'use client';

import { c as _c } from "react/compiler-runtime";
import FormInputError from '@/app/_components/FormInputError';
import ProductOptionSelect from './ProductOptionSelect';
const Selection = t0 => {
  const $ = _c(17);
  const {
    selection,
    setOption,
    selectedOptions,
    selectionErrors,
    displayErrors
  } = t0;
  let selectedValue = null;
  if (selectedOptions && selectedOptions[selection.selection_id]) {
    selectedValue = selectedOptions[selection.selection_id].option_id;
  }
  let selectedOption = null;
  if (selectedOptions && selectedOptions[selection.selection_id] && selectedOptions[selection.selection_id].option_id) {
    selectedOption = selectedOptions[selection.selection_id];
  }
  const hasError = displayErrors && selectionErrors[selection.selection_id];
  const isRequired = selection.required !== false;
  let t1;
  if ($[0] !== hasError || $[1] !== selection.selection_id || $[2] !== selectionErrors) {
    t1 = hasError && <FormInputError id={`selection_${selection.selection_id}-error`} message={selectionErrors[selection.selection_id]} />;
    $[0] = hasError;
    $[1] = selection.selection_id;
    $[2] = selectionErrors;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = "selection_" + selection.selection_id;
  const t3 = hasError ? `selection_${selection.selection_id}-error` : undefined;
  let t4;
  if ($[4] !== hasError || $[5] !== isRequired || $[6] !== selectedOption || $[7] !== selectedValue || $[8] !== selection.options || $[9] !== selection.selection_message || $[10] !== setOption || $[11] !== t2 || $[12] !== t3) {
    t4 = <ProductOptionSelect identifier={t2} label={selection.selection_message} options={selection.options} onSelect={setOption} selectedValue={selectedValue} selectedOption={selectedOption} className="mb-6" required={isRequired} invalid={hasError} ariaDescribedBy={t3} />;
    $[4] = hasError;
    $[5] = isRequired;
    $[6] = selectedOption;
    $[7] = selectedValue;
    $[8] = selection.options;
    $[9] = selection.selection_message;
    $[10] = setOption;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t1 || $[15] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[14] = t1;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default Selection;